export const createSystemSlice = (set) => ({
    isNotificationsEnabled: false,
    setIsNotificationsEnabled: (isNotificationsEnabled) => set(() => ({ isNotificationsEnabled })),
});
//# sourceMappingURL=system.js.map